import { PageHeader } from "@/components/site/PageHeader";
import { ProductCatalog } from "@/components/products/ProductCatalog";
import { DistributionSection } from "@/components/site/DistributionSection";
import { CTASection } from "@/components/site/CTASection";
import { IMAGES } from "@/data/content";

export default function Products() {
  return (
    <div data-testid="products-page">
      <PageHeader
        eyebrow="Products & Services"
        title="Explore our Range"
        subtitle="From hand-finished model engines to indigenous defence RPAS — browse the complete range, filter by category, and open any product for full specifications."
        image={IMAGES.cnc}
      />

      <ProductCatalog />

      <DistributionSection id="partner-products" eyebrow="Distributed Brands · Partner Products" />

      <CTASection
        title="Need a custom build?"
        subtitle="Tell us your requirement — trainer fleet, competition kit, or a mission-specific UAS — and we will engineer it in-house."
        primaryLabel="Request a Quote"
        secondaryLabel="Explore Gallery"
        secondaryTo="/gallery"
      />
    </div>
  );
}
